import React from 'react';

const defaultSize = 20;

/** Eye open = password visible, click to hide (e.g. FormField password toggle) */
export const EyeOpenIcon: React.FC<{ size?: number; className?: string }> = ({
  size = defaultSize,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className={className}
  >
    <path
      d="M2.5 10C2.5 10 5 4.5 10 4.5C15 4.5 17.5 10 17.5 10C17.5 10 15 15.5 10 15.5C5 15.5 2.5 10 2.5 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Eye with slash = password hidden, click to show (e.g. FormField password toggle) */
export const EyeOffIcon: React.FC<{ size?: number; className?: string }> = ({
  size = defaultSize,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className={className}
  >
    <path
      d="M3.5 3.5L16.5 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.5 8.5C8.02 9.18 7.75 10 7.75 10.875C7.75 12.6 9.2 14 11 14C11.9 14 12.7 13.65 13.3 13.1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.5C4.5 6.5 3.5 8.5 2.5 10C2.5 10 5 15.5 10 15.5C11.2 15.5 12.3 15.2 13.3 14.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 13C16.1 12 16.9 10.7 17.5 10C17.5 10 15 4.5 10 4.5C9.4 4.5 8.8 4.6 8.3 4.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
